import templateUrl from "./work-order-detail-container.component.html";

export const WorkOrderDetailContainerComponent = {
    templateUrl,
    bindings: {
        workOrder: "<",
        office: "<",
        corporation: "<",
        employee: "<"
    }
};
